import React from "react";
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {WizTableForm} from "@/containers/common";

let {WizPopover, WizButton} = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })


export default (self, type, info) => {
  return [
    {
      title: '账号',
      name: 'userName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '任职',
      name: 'identityList',
      tableItem: {
        render: (text, record) =>{
          if (!text?.length) {
            return '暂无任职'
          }
          const getIdentityTitle = (identity, defaultTitle) => {
            return identity && Object.keys(identity).length ? `${identity.orgName} - ${identity.positionName}` : defaultTitle
          }
          return (
            <WizPopover content={text?.map(item => getIdentityTitle(item)).map(item => <p>{item}</p>)} placement="rightTop">
              {getIdentityTitle(text?.[0], '暂无任职')}
              {text?.length > 1 ? ' . . . ' : ''}
            </WizPopover>
          )
        }
      }
    },
    type.indexOf('favorites') !== -1 ? {
      title: '收藏时间',
      name: 'favoritesTime',
      tableItem: {}
    } : null,
    type.indexOf('like') !== -1 ? {
      title: '点赞时间',
      name: 'operateTime',
      tableItem: {}
    } : null,
    type.indexOf('read') !== -1 ? {
      title: '阅读时间',
      name: 'operationTime',
      tableItem: {}
    } : null,
    type.indexOf('download') !== -1 ? {
      title: '下载时间',
      name: 'operationTime',
      tableItem: {}
    } : null,
  ].filter(item => !!item)
}
